/**
 * 过滤特殊字符
 *
 * @param text - 要过滤的文本
 * @returns 过滤后的文本
 */
export const filterSpecialChars = (text: string) => {
    return text.replace(/[\x00-\x09\x0b-\x1f\x7f-\x9f]/gi, '');
};

/**
 * 判断字符串是否为单个字符
 *
 * @param str - 要判断的字符串
 * @returns 是否为单个字符
 */
export const isSingleCharacterSegmenter = (str: string): boolean => {
    if (typeof Intl.Segmenter === 'undefined') {
        return Array.from(str).length === 1;
    }

    const segmenter = new Intl.Segmenter();
    const segments = Array.from(segmenter.segment(str));
    return segments.length === 1;
};
